import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Images } from "./../../assets/common";
import DoneIcon from "@mui/icons-material/Done";
import { useHistory } from "react-router-dom";
import ApiService from "./../../services/api-service";
import { getErrorString } from "./../../constants/function";
import notifier from "./../../components/Notifier";
import { useDispatch } from "react-redux";

import Loader from "./../../components/Loader";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useTranslation } from "react-i18next";
export default function Upgrade() {
  const { t } = useTranslation("common");
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const upgrade = async () => {
    try {
      setLoading(true);
      const response = await ApiService.CREATE_SUBSCRIPTIONS({
        deviceType: 1,
      });
      setLoading(false);
      dispatch(getBalance());
      history.push("/app/Profile");
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) === "User Already has premium Access")
        notifier.info(getErrorString(error));
      else notifier.error(getErrorString(error));
    }
  };
  return (
    <Box
      sx={{
        // backgroundColor: "#262626",
        // backgroundColor: "#090909",
        paddingBottom: "100px",
      }}
    >
      <Stack>
        <img style={{ width: "100%" }} src={Images.upgrade1} alt="upgrade" />
        <Box
          sx={{
            margin: "auto",
            padding: "24px",
          }}
        >
          <Stack spacing={2}>
            <Typography
              sx={{
                fontSize: "24px !important",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {t("premium.header")}
            </Typography>
            <Stack spacing={2} textAlign="center">
              <Stack direction="row" alignItems="center">
                <DoneIcon
                  sx={{
                    backgroundColor: "#FFEE20",
                    borderRadius: "50%",
                    marginRight: "10px",
                    fontSize: "17px",
                  }}
                />
                <Typography className="fs-17">
                  {t("premium.subHeader1")}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center">
                <DoneIcon
                  sx={{
                    backgroundColor: "#FFEE20",
                    borderRadius: "50%",
                    marginRight: "10px",
                    fontSize: "17px",
                  }}
                />
                <Typography className="fs-17">
                  {t("premium.subHeader2")}
                </Typography>
              </Stack>
            </Stack>
            <Button
              sx={{ fontSize: "17px", fontWeight: "bold" }}
              variant="contained"
              color="primary"
              onClick={() => upgrade()}
            >
              {t("premium.button1")}
            </Button>
            <Button
              sx={{ fontSize: "17px", fontWeight: "bold" }}
              onClick={() => history.push("/app/home")}
            >
              {t("premium.button2")}
            </Button>
          </Stack>
        </Box>
      </Stack>
      {loading ? <Loader /> : null}
    </Box>
  );
}
